module.exports = __webpack_public_path__ + "static/media/mtto_produccion.8a0f77bf.svg";